import React, { useState } from 'react';
import { Mail, Loader2, Check, AlertCircle } from 'lucide-react';

const NewsletterForm = ({ className = "" }) => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle'); // idle, loading, success, error
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');
        setMessage('');

        // Simulation pour localhost
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            setTimeout(() => {
                setStatus('success');
                setMessage('Simulation: Inscrit !');
                setEmail('');
                setTimeout(() => {
                    setStatus('idle');
                    setMessage('');
                }, 5000);
            }, 1000);
            return;
        }

        try {
            const response = await fetch('/api/waitlist', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();

            if (response.ok) {
                setStatus('success');
                setMessage('Merci ! Vous êtes inscrit.');
                setEmail('');
                setTimeout(() => {
                    setStatus('idle');
                    setMessage('');
                }, 5000);
            } else {
                setStatus('error');
                setMessage(data.error || 'Une erreur est survenue.');
            }
        } catch (error) {
            console.error('Newsletter error:', error);
            setStatus('error');
            setMessage('Erreur de connexion.');
        }
    };

    return (
        <form onSubmit={handleSubmit} className={`relative ${className}`}>
            <div className="relative flex items-center">
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Votre email..."
                    required
                    disabled={status === 'loading' || status === 'success'}
                    className="w-full bg-white/10 border-2 border-white/20 rounded-full py-3 pl-5 pr-12 text-white placeholder-white/50 focus:outline-none focus:border-[#00f2ea] focus:bg-black/50 transition-all font-bold"
                />
                <button
                    type="submit"
                    disabled={status === 'loading' || status === 'success'}
                    className="absolute right-1 p-2 bg-white text-black rounded-full hover:bg-[#00f2ea] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {status === 'loading' ? (
                        <Loader2 size={18} className="animate-spin" />
                    ) : status === 'success' ? (
                        <Check size={18} />
                    ) : (
                        <Mail size={18} />
                    )}
                </button>
            </div>
            {message && (
                <div className={`absolute -bottom-8 left-0 text-xs font-bold ${status === 'error' ? 'text-[#ff0050]' : 'text-[#00f2ea]'}`}>
                    {status === 'error' && <AlertCircle size={12} className="inline mr-1" />}
                    {message}
                </div>
            )}
        </form>
    );
};

export default NewsletterForm;
